export default __webpack_public_path__ + "static/media/head03_zh_tw_pc@2x.10abe473.png";